// extracted by mini-css-extract-plugin
export default {"card":"LiquidityWidget_card__YfEIE","chartArea":"LiquidityWidget_chartArea__QMTfD"};